import kButton from './Button.vue'
import kDatePicker from './DatePicker.vue'
import kTelInput from './TelInput.vue'
import kStatus from './Status.vue'
import kCidSelector from './CidSelector.vue'
import kMultipleInputTag from './MultipleInputTag.vue'
import kMultipleSelector from './MultipleSelector.vue'
import kFilterSelected from './FilterSelected.vue'
import kFilterDropdown from './FilterDropdown.vue'
import kFilterFormDropdown from './FilterFormDropdown.vue'
import kNoAccessPermission from './NoAccessPermission.vue'
import kSearchInput from './SearchInput.vue'
import kTimePicker from './TimePicker.vue'
import kMultifunctionalInput from './MultifunctionalInput.vue'
import kToast from './toast.js'
import {
  KkIcon,
  KkMessage,
  KkButton,
  KkCheckbox,
  KkTabs,
  KkTabsContent,
  KkTextField,
  KkSelectWithMenu,
  KkSelectOption,
  KkRadioButtonGroup,
  KkRadioButtonItem,
  KkTextarea,
  KkTextLink,
  KkDropdown,
  KkDialog
} from '@kkday/web-design-system'

const initCommonConponents = {
  install: function(Vue) {
    Vue.component('KkIcon', KkIcon)
    Vue.component('KkMessage', KkMessage)
    Vue.component('KkButton', KkButton)
    Vue.component('KkCheckbox', KkCheckbox)
    Vue.component('KkTabs', KkTabs)
    Vue.component('KkTabsContent', KkTabsContent)
    Vue.component('KkTextField', KkTextField)
    Vue.component('KkSelectWithMenu', KkSelectWithMenu)
    Vue.component('KkSelectOption', KkSelectOption)
    Vue.component('KkRadioButtonGroup', KkRadioButtonGroup)
    Vue.component('KkRadioButtonItem', KkRadioButtonItem)
    Vue.component('KkTextarea', KkTextarea)
    Vue.component('KkTextLink', KkTextLink)
    Vue.component('KkDropdown', KkDropdown)
    Vue.component('KkDialog', KkDialog)
    Vue.component('kButton', kButton)
    Vue.component('kDatePicker', kDatePicker)
    Vue.component('kTelInput', kTelInput)
    Vue.component('kStatus', kStatus)
    Vue.component('kCidSelector', kCidSelector)
    Vue.component('kMultipleInputTag', kMultipleInputTag)
    Vue.component('kMultipleSelector', kMultipleSelector)
    Vue.component('kFilterSelected', kFilterSelected)
    Vue.component('kFilterDropdown', kFilterDropdown)
    Vue.component('kFilterFormDropdown', kFilterFormDropdown)
    Vue.component('kNoAccessPermission', kNoAccessPermission)
    Vue.component('kSearchInput', kSearchInput)
    Vue.component('kTimePicker', kTimePicker)
    Vue.component('kMultifunctionalInput', kMultifunctionalInput)
    Vue.prototype.$kToast = kToast
  }
}

export default initCommonConponents
